import { Assets } from '@itero/assets-bff-sdk';
import { utils } from '../utils';
import logger from '../logger';
import { delayUtils } from './delay-utils';
import { featureAvaliability } from '../feature-avaliability/feature-avaliability-service';

const pollForAssetCreation = async (getAssetFunc) => {
  const INITIAL_ATTEMPTS = 15;
  const INITIAL_INTERVAL = 3000;
  const FINAL_INTERVAL = 15000;
  const TIMEOUT_THRESHOLD = 360000;
  let isTimeoutReached = false;

  delayUtils.delayCallback(TIMEOUT_THRESHOLD, () => {
    isTimeoutReached = true;
  });

  for (let i = 0; i < INITIAL_ATTEMPTS; i++) {
    try {
      return await getAssetFunc();
    } catch (error) {
      logger
        .error(`pollForAssetCreation: error: ${error}`)
        .data({ module: 'itr-fetcher' })
        .to(['host'])
        .end();
      await delayUtils.delay(INITIAL_INTERVAL);
    }
  }

  while (!isTimeoutReached) {
    try {
      return await getAssetFunc();
    } catch (error) {
      logger
        .error(`pollForAssetCreation: error: ${error}`)
        .data({ module: 'itr-fetcher' })
        .to(['host'])
        .end();
      await delayUtils.delay(FINAL_INTERVAL);
    }
  }
};

let assetSdkInstance = null;

const getAssetSdk = () => {
  if (assetSdkInstance) {
    return assetSdkInstance;
  }

  if (!utils) {
    return null;
  }
  const assetManagerUrl = utils.getAssetManagerUrl();
  if (!assetManagerUrl) {
    return null;
  }

  const shouldEnableCaching = featureAvaliability.getIsAssetsSdkCachingEnabled();

  assetSdkInstance = new Assets({ assetsBffUrl: assetManagerUrl, enableCache: shouldEnableCaching });
  return assetSdkInstance;
};

const disposeAssetSdk = () => {
  if (assetSdkInstance) {
    assetSdkInstance.dispose();
    assetSdkInstance = null;
  }
};

export const assetManagerUtils = {
  getAssetSdk,
  pollForAssetCreation,
  disposeAssetSdk,
};
